import { makeAutoObservable } from 'mobx'
import { openApi } from '../../helpers/request'
import dayjs from 'dayjs'
import { FormEvent } from 'react'

export interface UserInterface {
    id: number
    firstname: string
    lastname: string
    surname: string
    email: string
    external_id: string
    phone: string
    birthday: number
    orders: any
    is_blocked: boolean
    companies: any[],
    curator_id: number | null,
    categories: number[]
}

class UsersController {

    users: UserInterface[] = []
    user: UserInterface = {
        id: 0,
        firstname: '',
        lastname: '',
        surname: '',
        email: '',
        phone: '',
        external_id: '',
        birthday: 0,
        orders: {},
        is_blocked: false,
        companies: [],
        curator_id: null,
        categories: []
    }

    stat: any[] = []

    list = {
        limit: 20,
        offset: 0,
        count: 0,
        page: 1
    }

    list_filter: any = {
        name: null,
        email: null,
        phone: null
    }

    bonuses_add = 1
    bonuses_delete = 1
    bonuses_add_combustion_date: any = null
    bonus_balance = 0
    bonuses = []
    bonuses_limit = 10
    bonuses_page = 1
    bonuses_total = 0
    bonus_table = 1

    modalCompany = {
        open: false,
        inn: null,
        list: []
    }

    curators: any[] = []

    partners: any[] = []

    filter: any = {
        partners: [],
        managers: [],
        created_at_from: null,
        created_at_to: null,
        activated_at_from: null,
        activated_at_to: null,
        status: null
    }

    constructor() {
        makeAutoObservable(this)
    }

    deleteBonuses(e: FormEvent) {
        e.preventDefault()

        let data = new FormData()
        data.append('count_bonus', `${this.bonuses_delete}`)
        data.append('user_id', `${this.user.id}`)

        openApi('post', `/user/bonus/delete`, data)
          .then(result => {
              this.bonuses_delete = 1
              this.bonus_table = 1
              this.getHistory()
          })
    }

    addBonuses(e: FormEvent) {
        e.preventDefault()

        let data = new FormData()
        data.append('count_bonus', `${this.bonuses_add}`)
        data.append('user_id', `${this.user.id}`)
        if(this.bonuses_add_combustion_date) data.append('combustion_date', `${this.bonuses_add_combustion_date}`)

        openApi('post', `/user/bonus/add`, data)
            .then(result => {
                this.bonuses_add = 1
                this.bonuses_add_combustion_date = null
                this.bonus_table = 1
                this.getHistory()
            })
    }

    getList() {
        let uri = `/users?limit=${this.list.limit}&offset=${this.list.offset}`

        if(this.list_filter.name) uri += `&filter[name]=${this.list_filter.name}`
        if(this.list_filter.phone) uri += `&filter[phone]=${this.list_filter.phone}`
        if(this.list_filter.email) uri += `&filter[email]=${this.list_filter.email}`


        openApi('get', uri)
            .then(result => {
                console.log(result)
                result = result.data
                this.list.count = result.count
                this.users = result.list
            })
    }

    getOne(id: any) {
        if(id > 0)
            openApi('get', `/users/${id}`)
                .then(result => {
                    console.log(result)
                    if(result.data.curator) {
                        this.getCurators()
                    }
                    this.user = result.data
                    this.getHistory()
                })
    }

    exportUsers(type: string) {
        openApi('get', `/users/export/${type}`)
            .then(result => {
                 window.open(result.data)
            })
    }

    editBirthday(userId: any, e: any) {
        const data = new FormData()

        if(e) {
            let date = e.startOf('day')
            console.log(`${date.unix()}`)
            this.user.birthday = date.unix()
            data.append('birthday', `${date.unix()}`)
        }

        if(userId > 0)
            openApi('post', `/user/edit/${userId}`, data)
                .then(result => {
                    this.getOne(userId)
                })
                .catch(error => console.log(error))
    }

    getHistory(type = 1) {
        openApi('get', `/user/bonuses/${this.user.id}/all?limit=${this.bonuses_limit}&page=${this.bonuses_page}&type_table=${type}`)
            .then(result => {
                console.log(result)
                result = result.data
                this.bonuses = result.list && Array.isArray(result.list) ? result.list : []
                this.bonus_balance = result.balance
                this.bonuses_total = result.total
            })
            .catch(error => console.log(error))
    }

    setTypeTable(e: any) {
        if(e && typeof e === 'number' && e >= 1 && e <= 2 && e !== this.bonus_table) {
            this.bonuses_page = 1
            this.bonuses_total = 0
            this.getHistory(e)
            this.bonus_table = e
        }
    }

    setFilter(name: string, value: string) {
        this.list_filter[name] = value !== '' ? value : null
        this.list.offset = 0
        this.getList()
    }

    blockUser(user_id = 0) {
        if(user_id > 0) {
            openApi('post', `/users/block/${user_id}`)
              .then(result => {
                  this.getOne(user_id)
              })
              .catch(error => console.log(error))
        }
    }

    searchCompany() {
        openApi('get', `/users/search_inn?user_id=${this.user.id}&inn=${this.modalCompany.inn}`)
          .then(result => {
              console.log(result)
              this.modalCompany.list = result.data
          })
          .catch(error => console.log(error.response))
    }

    openSearchCompany() {
        this.modalCompany = {
            open: true,
            inn: null,
            list: []
        }
    }

    closeSearchCompany() {
        this.modalCompany = {
            open: false,
            inn: null,
            list: []
        }
    }

    addCompanyToUser(company: any) {
        const data = new FormData()
        data.append('user_id', `${this.user.id}`)

        data.append('type', `${company.type}`);
        data.append('inn', `${company.inn}`);
        data.append('ogrn', `${company.ogrn}`);
        if(company.name_short) data.append('name_short', `${company.name_short}`);
        if(company.name) data.append('name', `${company.name}`);
        if(company.date_ogrn) data.append('date_ogrn', `${company.date_ogrn}`);
        data.append('status', `${+ company.status}`);
        if(company.address) data.append('address', `${company.address}`);
        if(company.activity) data.append('activity', `${company.activity}`);
        if(company.fio) data.append('fio', `${company.fio}`);

        openApi('post', '/users/company', data)
          .then(result => {
              console.log(result)
              this.closeSearchCompany()
              this.getOne(this.user.id)
          })
    }

    deleteCompanyFromUser(id: number) {
        openApi('delete', `/users/company/${this.user.id}/${id}`)
          .then(result => {
              console.log(result)
              this.getOne(this.user.id)
          })
    }

    save(e: FormEvent) {
        e.preventDefault()

        const data = new FormData()

        data.append('firstname', this.user.firstname)
        data.append('lastname', this.user.lastname)
        data.append('surname', this.user.surname)
        data.append('email', this.user.email)
        data.append('phone', this.user.phone)
        data.append('external_id', this.user.external_id)
        data.append('birthday', `${this.user.birthday}`)
        data.append('curator_id', this.user.curator_id ? `${this.user.curator_id}` : '')

        data.append('is_categories', '1')

        this.user.categories.map((el: any, i: number) => data.append(`categories[${i}]`, `${el}`))

        openApi('post', `/user/edit/${this.user.id}`, data)
            .then(result => {
                console.log(result)
                if(this.user.id > 0)
                    this.getOne(this.user.id)
            })
            .catch(error => console.log(error.response))
    }

    getCurators() {
        openApi('get', `/manager/list?limit=1000000page=1`)
            .then(result => {
                console.log(result)
                this.curators = result.data
            })
    }

    getStatistic() {
        let uri = `/user/stat?limit=${this.list.limit}&page=${this.list.page}`

        if(this.filter.activated_at_from) uri += `&activated_at_from=${this.filter.activated_at_from.unix()}`
        if(this.filter.activated_at_to) uri += `&activated_at_from=${this.filter.activated_at_to.unix()}`
        if(this.filter.created_at_from) uri += `&created_at_from=${this.filter.created_at_from.unix()}`
        if(this.filter.created_at_to) uri += `&created_at_to=${this.filter.created_at_to.unix()}`
        if(this.filter.status) uri += `&status=${this.filter.status}`
        if(this.filter.managers)
            this.filter.managers.map((item: any, index: number) => {
                uri += `&managers[${index}]=${item}`
            })
        if(this.filter.partners)
            this.filter.partners.map((item: any, index: number) => {
                uri += `&partners[${index}]=${item}`
            })

        console.log(uri)

        openApi('get', uri)
            .then(result => {
                console.log(result)
                this.list.count = result.total
                this.stat = result.data
                this.partners = result.partners
                this.curators = result.curators
            })
            .catch(error => {
                console.log(error.response)
            })
    }
}

export default new UsersController()